<template>
  <div class="memberWealth">
    <el-tabs class="el-tabs-custom el-tabs-wealth" v-model="current">
      <el-tab-pane
        v-for="item in types"
        :label="item.label"
        :name="item.type"
        :key="item.type"
      ></el-tab-pane>
    </el-tabs>
    <div class="tab-content">
      <div v-show="current == 1" class="contract">
        <img class="icon" src="@/assets/images/info@2x.png" />
        <router-link
          :to="{ name: 'Contract', query: { key: 'coupon_use_contract' } }"
        >
          使用规则说明
        </router-link>
      </div>
      <el-tabs
        class="el-tabs-custom el-tabs-coupon"
        v-if="current == 1"
        v-model="currentCouponType"
        @tab-click="changeCouponType"
      >
        <el-tab-pane
          v-for="(value, key) in couponStatus"
          :label="value"
          :name="key"
          :key="key"
        >
          <ul class="clear coupons" v-if="couponList.length">
            <li
              v-for="(item, index) in couponList"
              :key="index"
              :class="{ valid: item.status == 0 }"
            >
              <div class="left">
                <div class="price">
                  <Currency class="currency"></Currency>
                  <span class="discounted_price">
                    {{ item.discounted_price | price }}
                  </span>
                  <span class="full_reduction">
                    满{{ item.full_reduction | price }}可用
                  </span>
                </div>
                <div class="bottom">
                  <div class="scope" v-if="item.dis_type == 1">
                    {{
                      item.scope_type == 1
                        ? "全部课程"
                        : item.scope_type == 2
                        ? "指定课程分类"
                        : "指定课程"
                    }}可用
                  </div>
                  <div class="scope" v-else-if="item.dis_type == 4">
                    {{
                      item.scope_type == 1
                        ? "全部约课"
                        : item.scope_type == 2
                        ? "指定讲师"
                        : ""
                    }}
                  </div>
                  <div class="scope" v-else-if="item.dis_type == 2">
                    {{
                      item.scope_type == 1
                        ? "全部实物商品"
                        : item.scope_type == 2
                        ? "指定实物商品分类"
                        : "指定实物商品"
                    }}
                  </div>
                  <div class="scope" v-else-if="item.dis_type == 5">
                    {{
                      item.scope_type == 1
                        ? "全部班级"
                        : item.scope_type == 2
                        ? "指定班级教学分类"
                        : item.scope_type == 3
                        ? "指定班级"
                        : "指定班级年级"
                    }}
                  </div>
                  <div class="scope" v-else-if="item.dis_type == 6">
                    {{
                      item.scope_type == 1
                        ? "全部电子书"
                        : item.scope_type == 2
                        ? "指定电子书分类"
                        : "指定电子书"
                    }}
                  </div>
                  <div class="time">
                    有效期：{{ item.valid_start }}-{{ item.valid_end }}
                  </div>
                </div>
              </div>
              <div class="line"></div>
              <div class="right">
                <a @click="goToUsePage(item)" v-if="item.status == 0">
                  立即使用
                </a>
                <span v-else-if="item.status == 1">已使用</span>
                <span v-else-if="item.status == 2">已过期</span>
              </div>
            </li>
          </ul>
          <div v-else class="center" style="padding: 20px 0">暂无优惠券</div>
        </el-tab-pane>
      </el-tabs>
      <div v-if="current == 2">
        <div class="clear" style="padding: 0 24px">
          <span class="f-left title" v-if="cardRecords.length">兑换记录</span>
          <el-button class="f-right" type="warning" @click="beginCard">
            学习卡兑换
          </el-button>
        </div>
        <ul class="records" v-if="cardRecords.length">
          <li v-for="record in cardRecords" :key="record.study_card_id">
            <div class="f-left left">
              <div class="point"></div>
              <div class="line"></div>
            </div>
            <div class="f-left">
              <div class="time">
                兑换时间：{{
                  new Date(record.used_at * 1000).format("yyyy-MM-dd hh:mm:ss")
                }}
              </div>
              <div class="name">商品内容：{{ record.title }}</div>
              <div class="number">卡号：{{ record.card_number }}</div>
            </div>
            <div style="clear: both"></div>
          </li>
        </ul>
        <div v-else class="center" style="padding: 20px 0">暂无兑换记录</div>
      </div>
    </div>
    <el-dialog
      class="dialog-custom dialog-card"
      title="学习卡兑换"
      :visible.sync="showDialog"
      width="500px"
    >
      <div class="card-form-item">
        <label>卡号：</label>
        <el-input v-model="card_number" placeholder="请输入卡号"></el-input>
      </div>
      <div class="card-form-item">
        <label>密码：</label>
        <el-input v-model="card_pwd" placeholder="请输入密码"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitCard">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      class="dialog-custom"
      title="配送至"
      :visible.sync="showAddressModal"
      width="681px"
      appendToBody
      center
    >
      <Address
        class="address-wealth"
        v-model="addressId"
        tip="此地址只用于邮寄实体教材，请准确填写"
      ></Address>
      <div slot="footer" class="dialog-footer clear">
        <el-button
          type="default"
          size="small"
          @click="showAddressModal = false"
        >
          取消
        </el-button>
        <el-button type="primary" size="small" @click="confirmAddress">
          立即兑换
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Address from "../../components/Address";
import { triggerLoaded } from "@/components/LoadContainer.vue";

export default {
  name: "MemberWealth",
  components: {
    Address,
  },
  data() {
    return {
      current: "",
      types: [],
      currentCouponType: "0",
      couponStatus: {
        0: "未使用",
        1: "已使用",
        2: "已过期",
      },
      couponList: [],
      showDialog: false,
      card_number: "",
      card_pwd: "",
      cardRecords: [],
      showAddressModal: false,
      addressId: "",
    };
  },
  computed: {
    commonSetting() {
      return this.$store.state.commonSetting;
    },
  },
  watch: {
    commonSetting() {
      this.setTypes();
      this.getData();
    },
  },
  async created() {
    this.setTypes();
    await this.getData();
    triggerLoaded(this);
  },
  methods: {
    setTypes() {
      if (this.commonSetting.switch_coupon_module === 1) {
        this.types.push({
          type: "1",
          label: "优惠券",
        });
      }
      if (this.commonSetting.switch_study_module === 1) {
        this.types.push({
          type: "2",
          label: "学习卡",
        });
      }
      if (this.types.length > 0) {
        this.current = this.types[0].type;
      }
    },
    async getData() {
      if (this.commonSetting.switch_coupon_module === 1) {
        await this.getCoupon();
      }
      if (this.commonSetting.switch_study_module === 1) {
        await this.getCardRecord();
      }
    },
    async getCoupon() {
      this.couponList = await this.$http.get("/api/app/coupon", {
        status: this.currentCouponType,
      });
    },
    async getCardRecord() {
      this.cardRecords = await this.$http.post("/api/app/myStudy");
    },
    async changeCouponType() {
      await this.getCoupon();
    },
    beginCard() {
      this.showDialog = true;
      this.card_number = "";
      this.card_pwd = "";
    },
    async confirmSubmitCard() {
      let data = {
        card_number: this.card_number,
        card_pwd: this.card_pwd,
      };
      if (this.addressId) {
        data.address_id = this.addressId;
      }
      await this.$http.post("/api/app/checkout/studyCard", data);
      this.$success("兑换成功");
      this.showDialog = false;
      await this.getCardRecord();
    },
    async submitCard() {
      if (this.card_number == "") {
        await this.$info("请输入卡号");
        return;
      }
      if (this.card_pwd == "") {
        await this.$info("请输入密码");
        return;
      }
      let data = await this.$http.get(
        "/api/app/check/course/" + this.card_number + "/" + this.card_pwd,
      );
      if (data.status == 0) {
        this.showAddressModal = true;
      } else {
        await this.confirmSubmitCard();
      }
    },
    async confirmAddress() {
      if (!this.addressId) {
        this.$info("请选择收货地址");
        return;
      }
      await this.confirmSubmitCard();
      this.showAddressModal = false;
    },
    goToUsePage(item) {
      this.$services.CouponService.goToUsePage(item);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/varibles.scss";
.memberWealth {
  background: #fff;
}
.el-tabs-wealth {
  padding: 12px 24px 0 24px;
  /deep/ {
    .el-tabs__nav-scroll {
      padding-left: 0;
    }
  }
}

.tab-item span {
  border-right: none;
}

.tab-content {
  background-color: white;
  padding: 0 0 24px 0;
  position: relative;
  border-radius: 0 0 10px 10px;

  .contract {
    position: absolute;
    z-index: 9;
    top: 6px;
    right: 25px;

    .icon {
      width: 13px;
    }

    * {
      vertical-align: middle;
    }

    a {
      font-size: 14px;
      color: #8c8c8c;
      margin-left: 4px;
    }
  }
}

.el-tabs-coupon {
  /deep/ .el-tabs__header {
    padding: 0 24px 0 24px;
  }
  /deep/ {
    .el-tabs__nav-scroll {
      padding-left: 0;
    }

    .el-tabs__item {
      padding-left: 16px !important;
      padding-right: 16px !important;

      &.is-active {
        color: $primary-color !important;

        &::after {
          height: 2px;
          border-radius: 0;
        }
      }
    }
  }
}

.coupons {
  padding-left: 25px;

  li {
    height: 148px;
    float: left;
    margin-right: 56px;
    margin-top: 40px;
    color: #b7b7b7;
    position: relative;

    &:nth-child(1),
    &:nth-child(2) {
      margin-top: 27px;
    }

    .left {
      float: left;
      box-sizing: border-box;
      padding-left: 15px;
      width: 302px;
      height: 100%;
      background-image: url(../../images/member/coupon-invalid-left@3x.png);
      background-size: 302px 148px;
      background-repeat: no-repeat;
    }

    .line {
      position: absolute;
      width: 4px;
      height: 100%;
      right: 81px;
      background-image: url(../../images/member/coupon-invalid-line@3x.png);
      background-size: 4px 116px;
      background-position: center;
      background-repeat: no-repeat;
    }

    .right {
      float: left;
      width: 82px;
      height: 100%;
      background-image: url(../../images/member/coupon-invalid-right@3x.png);
      background-size: 82px 148px;
      background-repeat: no-repeat;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;

      span {
        font-size: 22px;
        writing-mode: vertical-lr;
        color: #b7b7b7;
      }

      a {
        cursor: pointer;
      }
    }

    &:nth-child(2n) {
      margin-right: 0;
    }

    &.valid {
      color: #e14641;

      .left {
        background-image: url(../../images/member/coupon-left@3x.png);
      }

      .line {
        background-image: url(../../images/member/coupon-line@3x.png);
      }

      .right {
        background-image: url(../../images/member/coupon-right@3x.png);

        a {
          color: white;
          font-size: 22px;
          writing-mode: vertical-lr;
        }
      }

      .bottom {
        .scope {
          font-size: 15px;
          font-weight: 500;
          color: #595959;
        }

        .time {
          font-size: 13px;
          font-weight: 500;
          color: #595959;
        }
      }
    }

    .price {
      padding-top: 11px;
    }

    .currency {
      font-size: 14px;
    }

    .discounted_price {
      font-size: 29px;
      margin: 0 5px;
    }

    .bottom {
      position: absolute;
      left: 15px;
      bottom: 11px;

      .scope {
        font-size: 15px;
        margin-bottom: 6px;
      }

      .time {
        font-size: 13px;
      }
    }
  }
}

.card-form-item {
  display: flex;
  margin-bottom: 30px;
  align-items: center;

  label {
    margin-right: 16px;
    white-space: nowrap;
    color: #8c8c8c;
  }

  &:last-child {
    margin-bottom: 0;
  }

  /deep/ {
    .el-input__inner {
      height: 34px;
      line-height: 34px;
      font-size: 15px;
      color: #3e403f;

      &::placeholder {
        color: #b7b7b7;
      }
    }
  }
}

.title {
  font-size: 16px;
  font-weight: 500;
  color: rgba(89, 89, 89, 1);
}

.records {
  li {
    padding-bottom: 34px;
    font-size: 14px;
    color: rgba(89, 89, 89, 1);
    position: relative;

    .left {
      margin-right: 12px;
    }

    .point {
      width: 6px;
      height: 6px;
      background-color: $primary-color;
      border-radius: 100%;
      margin-top: 5px;
    }

    .line {
      width: 2px;
      background-color: #e9e9e9;
      height: 98px;
      top: 11px;
      position: absolute;
      left: 2px;
    }

    .time {
      margin-bottom: 8px;
    }

    .name {
      margin-bottom: 4px;
    }
  }
}
/deep/ {
  .address-wealth {
    .empty {
      .img-loc,
      .img-add {
        margin-left: 0;
      }
    }
  }
}
</style>
